<template>
  <dialog-v2
    :show="show"
    :title="title"
    @close="$emit('close')"
    @save="save">
    <template slot="content">
      <v-layout row wrap>
        <v-flex xs12>
          <v-tabs
            v-model="selectedTab"
            grow>
            <v-tabs-slider color="k-orange-linear"></v-tabs-slider>
            <v-tab
              v-for="(tab, i) in tabs"
              :key="`tab-${i}`"
              ripple>
              {{ tab.title }}
            </v-tab>
            <v-tab-item
              v-for="(tab, i) in tabs"
              :key="`tab-item-${i}`">
              <template-textarea
                v-if="tab.type !== 'sms'"
                v-model="form[tab.name]"
                v-validate="'required'"
                :data-vv-name="tab.name"
                data-vv-scope="question"/>
              <template-textarea
                v-else-if="tab.type === 'sms'"
                v-model="(form.sms[(i - (tabs.length - (data.sms || []).length))] || {}).text"
                v-validate="(form.sms[(i - (tabs.length - (data.sms || []).length))] || {}).enabled ? 'required' : ''"
                :data-vv-name="tab.name"
                data-vv-scope="question" />
              <small class="red--text" v-if="errors.has(`question.${tab.name}`)">
                Debe ingresar un texto
              </small>
              <v-layout v-if="tab.name === 'failed_attempts_text'" row wrap align-center mt-3>
                <v-flex md5>
                  <span>Número máximo de intentos:</span>
                  <template v-if="errors.has('question.max_attempts')">
                    <br>
                    <small class="red--text">
                      {{ errors.first('question.max_attempts') }}
                    </small>
                  </template>
                </v-flex>
                <v-flex md1>
                  <v-text-field
                    v-model="form.max_attempts"
                    v-validate="'required|numeric|min_value:1'"
                    data-vv-name="max_attempts"
                    data-vv-scope="question"
                    class="text-xs-center pt-0"
                    color="black"
                    outline
                    placeholder="N°"
                    :hide-details="true"/>
                </v-flex>
              </v-layout>
              <v-layout v-if="tab.type === 'sms' && form.sms.length" row wrap align-center mt-3>
                <v-flex xs12>
                  <v-switch
                    v-model="form.sms[(i - (tabs.length - data.sms.length))].enabled"
                    label="Activo"
                    class="k-blue-linear-text"
                    :hide-details="true"/>
                </v-flex>
              </v-layout>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
    </template>
  </dialog-v2>
</template>

<script>
import DialogV2 from '@/components/global/DialogV2';
import TemplateTextarea from '@/components/bot_v4/Detail/TemplateTextarea';

export default {
  inject: ['$validator'],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  components: {
    DialogV2,
    TemplateTextarea,
  },
  data() {
    const emptyForm = {
      text: '',
      fallback_text: '',
      failed_attempts_text: '',
      max_attempts: 3,
      sms: [],
    };
    return {
      emptyForm,
      form: {
        ...emptyForm,
      },
      selectedTab: '0',
    };
  },
  computed: {
    tabs() {
      return [
        {
          name: 'text',
          title: 'Texto',
        },
        {
          name: 'fallback_text',
          title: 'Fallback',
        },
        {
          name: 'failed_attempts_text',
          title: 'Intentos máximos',
        },
        ...(this.data.sms || []).map(item => ({
          ...item,
          type: 'sms',
          name: `sms_${item.status_id}`,
          title: `SMS ${this.$store.getters.status(item.status_id).status}`,
        })),
      ];
    },
  },
  methods: {
    clearErrors() {
      Object.keys(this.form).forEach((key) => {
        this.$validator.errors.remove(key, 'question');
      });
    },
    save() {
      this.$validator.validateAll('question').then((validation) => {
        if (validation) {
          this.$emit('save', this.form);
        } else {
          const errors = this.$validator.errors.items.filter(item => item.scope === 'question');
          if (errors.length) {
            this.selectedTab = String(this.tabs.findIndex(item => item.name === errors[0].field));
          }
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.selectedTab = '0';
        this.form = {
          ...this.data,
        };
        this.clearErrors();
      } else {
        setTimeout(() => {
          this.form = {
            ...this.emptyForm,
          };
          this.clearErrors();
        }, 200);
      }
    },
  },
};
</script>

<style scoped>
.input-group--text-field.text-xs-center >>> input {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/bot_v4/Detail/QuestionDialog.vue